import { useRouter } from "next/router"

export function useParams(): [
  Record<string, string | string[] | undefined>,
  (params: Record<string, string | null | undefined>) => void,
] {
  const router = useRouter()
  const setParams = (params: Record<string, any>) => {
    const query = { ...router.query, ...params }

    for (const key in params) {
      if (!params[key]) {
        delete query[key]
      }
    }

    router.push(
      {
        pathname: router.pathname,
        query,
      },
      undefined,
      { shallow: true },
    )
  }
  return [router.query, setParams]
}
